import { ComponentType } from 'react';
import { Props as addToCartLayerProps } from './added-to-cart-layer.component';
import dynamic from 'next/dynamic';

const DynamicAddedToCartLayerComponent: ComponentType<addToCartLayerProps> = dynamic(
  () => import('./added-to-cart-layer.component')
);

export default DynamicAddedToCartLayerComponent;
